<template>
  <div class="p-develop">
    <!--头部-->
    <div
      class="head"
      :style="{
        backgroundImage: 'url(' + dataInfo.cover + ')'
      }"
    >
      {{ dataInfo.name }}
    </div>
    <!--内容-->
    <div class="g-box">
      <div class="time">
        <div class="swiper-container" id="swiper1">
          <div class="num swiper-wrapper">
            <div
              class="num_years swiper-slide"
              v-for="(item, index) of list"
              :key="index"
            >
              <div class="num_year">
                {{ item.title.slice(0, 4) }}
              </div>
              <div class="dian"></div>
            </div>
          </div>
        </div>

        <div class="time_lines">
          <div class="left_icon swiper-button-prev">
            <img src="../../assets/img/iconrightb.png" />
          </div>
          <div class="time_line"></div>
          <div class="right_icon swiper-button-next">
            <img src="../../assets/img/iconrightb.png" />
          </div>
        </div>
      </div>
      <div class="nav swiper-container" id="swiper2">
        <div class="swiper-wrapper">
          <div
            class="box-content swiper-slide"
            v-for="(item, index) of list"
            :key="index"
          >
            <div class="year">
              <div class="year-in">
                <div class="text">{{ item.title }}</div>
                <!-- <div class="eng">year</div> -->
              </div>
            </div>
            <div class="main">
              <div
                class="item"
                v-for="(el, i) in content ? JSON.parse(content) : []"
                :key="i"
              >
                <div class="item-left">
                  <div class="dot"></div>
                  <div class="month">{{ el.month }}</div>
                </div>
                <div class="item-right">
                  <div
                    class="right-con"
                    v-for="(element, i) in el.content"
                    :key="i"
                  >
                    <div class="dot"></div>
                    <div class="text">
                      {{ element.title }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../mixins/pageMain_mx";
import Swiper from "swiper/swiper-bundle";

export default {
  mixins: [pageMain_mx],
  data() {
    return {
      content: "",
      params: {},
      dataInfo: {},
      list: []
    };
  },
  mounted() {},
  methods: {
    async init() {
      this.params = this.$route.params;
      const dataInfo = await this.getMenuInfo(this.params.menuId);
      this.dataInfo = dataInfo;
      this.getAjax();
    },
    async getAjax() {
      const list = await this.getMenuList({
        pageNum: 1,
        pageSize: 999
      });
      this.list = list;
      await this.getDetail(list[0].id);
      this.$nextTick(() => {
        this.UserSwiper();
      });
    },
    async getDetail(id) {
      const res = await this.getAjaxInfo(id);
      this.content = res.content;
    },
    getId(i) {
      return this.list[i].id;
    },
    UserSwiper() {
      var thumbsSwiper = new Swiper("#swiper1", {
        loop: false,
        slidesPerView: 7,
        observer: true,
        observerParents: true,
        watchSlidesVisibility: true //防止不可点击
      });
      new Swiper("#swiper2", {
        loop: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        disabledClass: "my-button-disabled",
        observer: true,
        observerParents: true,
        thumbs: {
          swiper: thumbsSwiper,
          slideThumbActiveClass: "my-slide-thumb-active"
        },
        on: {
          slideChange: swiper => {
            this.getDetail(this.getId(swiper.realIndex));
          }
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.head {
  height: 280px;
  // width: 1920px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 60px;
  color: #fff;
  letter-spacing: 40px;
}
.time {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 100px;
  margin-bottom: 100px;
  .num {
    display: flex;
    justify-content: space-between;
    width: 900px;
    .num_years {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: center;
      height: 92px;
      cursor: pointer;
      .num_year {
        height: 30px;
        font-size: 22px;
        font-weight: 400;
        color: #656878;
        line-height: 30px;
        margin-bottom: 10px;
      }
      .dian {
        width: 20px;
        height: 20px;
        background: #0030aa;
        border: 6px solid #ffffff;
        border-radius: 20px;
        z-index: 1;
      }
    }
  }
  .time_lines {
    width: 1100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: -28px;
    margin-bottom: -30px;
    .time_line {
      width: 1000px;
      height: 6px;
      background-color: #0030aa;
    }
    .left_icon,
    .right_icon {
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
    .left_icon {
      transform: rotate(180deg);
    }
  }
}
.nav {
  .box-content {
    margin-bottom: 120px;
    .year {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100px;
      height: 100px;
      border-radius: 50%;
      background: #f1f1f2;
      &-in {
        text-align: center;
        .text {
          font-size: 30px;
          font-weight: 600;
          color: #000;
        }
        .eng {
          font-size: 16px;
          color: #a8aab8;
        }
      }
    }
    .main {
      margin-left: 50px;
      padding-top: 50px;
      .item {
        display: flex;
        margin-bottom: 50px;
        &-left {
          display: flex;
          width: 120px;
          .dot {
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background: #ff8012;
          }
          .month {
            margin-left: 20px;
            font-size: 18px;
            font-weight: 600;
            line-height: 1;
          }
        }
        &-right {
          .right-con {
            display: flex;
          }
          .dot {
            width: 8px;
            height: 8px;
            background: #c2c4d1;
            border-radius: 50%;
          }
          .text {
            position: relative;
            top: -5px;
            width: 800px;
            margin-left: 20px;
            font-size: 16px;
            padding-bottom: 20px;
          }
        }
      }
    }
  }
}
.my-slide-thumb-active ::v-deep {
  .num_year {
    height: 50px !important;
    font-size: 36px !important;
    font-weight: 600 !important;
    color: #0030aa !important;
    line-height: 50px !important;
  }
  .dian {
    width: 20px !important;
    height: 20px !important;
    background: #ffffff !important;
    border: 6px solid #0030aa !important;
  }
}
</style>
